
import _ from 'lodash'
import moment from 'moment'
import { Enums } from '@/model/util'

export const PerformanceValueType = Enums.create('performanceValueType', {
  ACTUAL: Enums.value('actual', 'report.performance.actual'),
  FORECAST: Enums.value('forecast', 'report.performance.forecast'),
  BUDGET: Enums.value('budget', 'report.performance.budget')
})

export class CategoryPerformance {
  constructor (data) {
    Object.assign(this, data)

    this.toDate = {}
    const month = moment().month()

    // Add total and to date values
    _.each(PerformanceValueType.values, t => {
      this[t.id] = _.sumBy(this.month_performances, t.id)
      this.toDate[t.id] = _.sumBy(_.filter(this.month_performances, p => p.month <= month + 1), t.id)
    })

    if (_.isNumber(this.toDate.actual) && _.isNumber(this.toDate.budget)) {
      this.toDate.delta = this.toDate.actual - this.toDate.budget
      this.toDate.deltaPercentage = (this.toDate.delta / this.toDate.budget)
    }
  }
}
